<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-6">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-6"></div>
      </div>
      <div class="row">
        <div class="col">
          <z-textarea
            v-model="text"
            name="description"
            label="Description"
            validate="required"
            :rows="5"
            :maxlength="40"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <z-select
            v-model="type"
            label="Nutrition Habit Type"
            validate="required"
            :options="icons"
          />
        </div>
        <div class="col-3 pl-2 pr-2">
          <div v-if="getIcon(type) !== null">
            <img :src="getIcon(type)" class="custom-icon" />
          </div>
        </div>
        <div class="col-3"></div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <div class="form-group custom-check">
            <input
              type="checkbox"
              id="allowTime"
              v-model="allowTime"
              class="z-checkbox-small"
              @click="isSave = true"
            />
            <label for="allowTime" class="custom-allow"
              >Do you wish to track the date/time of recorded nutrition
              habits?</label
            >
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              :disabled="attemptSave"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              v-show="isSave && !isAdd"
              class="btn btn-primary me-2"
              :disabled="attemptSave"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZTextarea from '@/Components/ZElements/TextArea'
export default {
  name: 'habit-dialog',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    ZTextarea,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
    }
  },
  computed: {
    ...mapGetters('nutrition', ['habit', 'habitIcons']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Habit'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Habit'
        } else if (this.habit) {
          _title = `Edit Habit (${this.habit.name})`
        }
      }
      return _title
    },
    id() {
      let _id = ''
      if (this.habit) {
        _id = this.habit.id
      }
      return _id
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    icons() {
      let _icons = []
      if (this.habitIcons) {
        this.habitIcons.forEach((element) => {
          _icons.push({
            id: parseInt(element.Value),
            name: element.Name,
            value: parseInt(element.Value),
          })
        })
      }
      return _icons
    },
    name: {
      get() {
        let _data = null
        if (this.habit) {
          _data = this.habit.name
        }
        return _data
      },
      set(value) {
        this.setHabitData({
          name: 'name',
          value: value,
        })
      },
    },
    text: {
      get() {
        let _data = null
        if (this.habit) {
          _data = this.habit.text
        }
        return _data
      },
      set(value) {
        this.setHabitData({
          name: 'text',
          value: value,
        })
      },
    },
    type: {
      get() {
        let _data = null
        if (this.habit) {
          _data = parseInt(this.habit.type)
        }
        return _data
      },
      set(value) {
        this.setHabitData({
          name: 'type',
          value: parseInt(value),
        })
      },
    },
    allowTime: {
      get() {
        let _is = false
        if (this.habit) {
          _is = this.habit.allowTime === 1 ? true : false
        }
        return _is
      },
      set(value) {
        this.setHabitData({
          name: 'allowTime',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('nutrition', ['setHabitData', 'saveHabit']),
    reset() {
      this.validErrors = []
      this.isSave = false
      this.invalidMessage = ''
    },
    getIcon(type) {
      let url = null
      let found = this.habitIcons.find(
        (x) => parseInt(x.Value) === parseInt(type)
      )
      if (found) {
        url = found.TextValue
      }
      return url
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.habit.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.habit.text === '') {
        valid = false
        this.validErrors.push('text')
      }
      if (this.show.isAdd) {
      }
      return valid
    },
    isAboutToSave() {
      this.attemptSave = true
    },
    async performSave(closeIt) {
      let success = false
      this.attemptSave = true
      let valid = this.validate()
      if (this.isSave && valid) {
        this.setHabitData({
          name: 'orgId',
          value: this.examineOrganization.id,
        })
        await this.saveHabit(this.habit)
        this.$emit('saved')
        success = true
        this.isSave = false
        if (closeIt || this.show.isAdd) {
          this.reset()
          this.$emit('close')
        }
      } else {
        success = false
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      this.attemptSave = false
      return success
    },
    close() {
      this.reset()
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-title-copy {
  color: red;
}
.custom-allow {
  margin-left: 5px;
}
.custom-icon {
  height: 48px;
  width: 48px;
  background-color: #0d6efd;
  padding: 7px;
  border-radius: 5px;
  text-align: center;
  margin-top: 15px;
  img {
    margin-top: 5px;
  }
}
</style>